import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import * as yup from 'yup';

import t from 'react-translate';
import NvTextInput from 'shared/components/inputs/nv-text-input';
import { config } from '../../../../../../config/pendo.config.json';
import { WorkdayAuthConfig } from './configuration';

interface ConfigurationFormProps {
  onSubmit: (data: WorkdayAuthConfig) => Promise<boolean>;
}

const ConfigurationForm: React.FC <ConfigurationFormProps> = ({ onSubmit }) => {
  const validationSchema = yup.object().shape({
    clientId: yup.string().required(t.VALIDATION.REQUIRED()),
    clientSecret: yup.string().required(t.VALIDATION.REQUIRED()),
    authUrl: yup.string().required(t.VALIDATION.REQUIRED()).url(t.VALIDATION.URL()),
    trackingUrl: yup.string().required(t.VALIDATION.REQUIRED()).url(t.VALIDATION.URL()),
    contentUrl: yup.string().required(t.VALIDATION.REQUIRED()).url(t.VALIDATION.URL()),
  });

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      clientId: '',
      clientSecret: '',
      authUrl: '',
      trackingUrl: '',
      contentUrl: '',
    },
    mode: 'onChange',
  });

  const { handleSubmit, formState } = methods;
  const { isDirty, isValid, isSubmitting } = formState;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className='align-self-start w-100'>
        <div className='text-body mb-4'>
          {t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN.DESCRIPTION()}
        </div>
        <NvTextInput
          type='text'
          name='clientId'
          withForm
          withLabel
          required
          placeholder={t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN.CLIENT_ID()}
          data-qa={config.pendo.settings.lms.modal.workdayLearn.clientId}
          className='mb-4'
          labelAlwaysShown
        />

        <NvTextInput
          type='password'
          name='clientSecret'
          withForm
          withLabel
          required
          placeholder={t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN.CLIENT_SECRET()}
          data-qa={config.pendo.settings.lms.modal.workdayLearn.clientSecret}
          className='mb-4'
          labelAlwaysShown
        />

        <NvTextInput
          type='url'
          name='authUrl'
          withForm
          withLabel
          required
          placeholder={t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN.AUTH_URL()}
          data-qa={config.pendo.settings.lms.modal.workdayLearn.authUrl}
          className='mb-4'
          labelAlwaysShown
        />

        <NvTextInput
          type='url'
          name='trackingUrl'
          withForm
          withLabel
          required
          placeholder={t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN.TRACKING_URL()}
          data-qa={config.pendo.settings.lms.modal.workdayLearn.trackingUrl}
          className='mb-4'
          labelAlwaysShown
        />

        <NvTextInput
          type='url'
          name='contentUrl'
          withForm
          withLabel
          required
          placeholder={t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN.CONTENT_URL()}
          data-qa={config.pendo.settings.lms.modal.workdayLearn.contentUrl}
          className='mb-4'
          labelAlwaysShown
        />

        <div className='mt-8 d-flex justify-content-center'>
          <Button
            variant='primary'
            type='submit'
            disabled={!isDirty || !isValid || isSubmitting}
            data-qa={config.pendo.settings.lms.modal.workdayLearn.cta}
          >
            {isSubmitting
              ? t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN.AUTHORIZING()
              : t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN.AUTHORIZE()}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default ConfigurationForm;
